import React from "react";
import { Grid, Typography, Box, Card, useTheme, Grid2 } from "@mui/material";
import { School, Computer, MonetizationOn, Book } from "@mui/icons-material";
import chroma from "chroma-js";
import MyCustomChip from "../../../_base/Chip";
import useSmoothResponsiveFontSize from "../../../../_hook/useSmoothResponsiveFontSize";

const BenefitSection = () => {
  const { palette } = useTheme();
  const customfontsize = useSmoothResponsiveFontSize();
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundColor: palette.primary.main,
        borderRadius: "16px",
        p: 3,
        my: 2,
      }}
    >
      <JourneySection  customfontsize={customfontsize}/>
      <Features  customfontsize={customfontsize}/>
    </Box>
  );
};


const JourneySection = ({ customfontsize }) => {
  const { palette } = useTheme();
  const primaryColor = palette.primary.main;

  // Lighten the primary color slightly
  const lightenedColor = chroma(primaryColor).brighten(0.2).hex(); // Adjust the value (0.2) to control the degree of lightening

  // Darken the primary color slightly
  const darkenedColor = chroma(primaryColor).darken(0.4).hex(); // Adjust the value (0.2) to control the degree of darkening

  return (
    <Grid2 container justifyContent="center" sx={{ mb: 6, width: "100%" }}>
      <Grid2 xs={12} xl={6}>
        <Box sx={{ textAlign: "center" }}>
          <MyCustomChip
            label="How We Start Journey"
            color={palette.grey[200]}
            backgroundColor={darkenedColor}
            hoverBackgroundColor={lightenedColor}
            fontSize={`${customfontsize}px`}
            border={`1px solid ${palette.grey[100]}`}
          />

          <Typography variant="h2" color="grey.100" sx={{ my: 4, fontSize: `${2 * customfontsize}px` }}>
            Start your Learning Journey Today!
          </Typography>
          <Typography variant="body1" color="grey.400" sx={{ fontSize: `${customfontsize}px` }}>
            Groove’s intuitive shared inbox makes team members together <br />
            organize, prioritize, and collaborate. In this episode.
          </Typography>
        </Box>
      </Grid2>
    </Grid2>
  );
};


const Features = ({ customfontsize }) => {
  const { palette } = useTheme();

 
  const featuresData = [
    {
      Icon: School,
      title: 'Your Academy is Wherever You Are',
      description: 'Future Learn Academy’s virtual classrooms allow you to study from any location, ensuring a top-tier learning experience tailored to your convenience.',
    },
    {
      Icon: Computer,
      title: 'Interactive and Engaging Teaching',
      description: 'Our lectures are crafted by experienced tutors who understand effective teaching methods. If you have any questions, your tutor is just a click away.',
    },
    {
      Icon: MonetizationOn,
      title: 'Affordable and Flexible',
      description: 'By eliminating traditional classroom costs, Future Learn Academy offers affordable and flexible learning options, with the ability to revisit lessons anytime.',
    },
    {
      Icon: Book ,
      title: 'More Than Just Academic Learning',
      description: 'At Future Learn Academy, we cultivate future leaders by providing essential skill development tools. Stay ahead with our cutting-edge resources.',
    },
  ];
  return (
    <Grid container spacing={3}>
      {featuresData.map((benefit, index) => (
        <Grid
          key={index}
          item
          xs={12}
          sm={12}
          md={6}
          lg={6}
          xl={3}
          xxl={3}
          style={{ alignItems: "stretch" }}
        >
          <Card
            sx={{
              display: "flex",
              flex: "1",

              flexDirection: "row",
              alignItems: "start",
              px: 2,
              py: 1,
              height: "100%",
              backgroundColor: palette?.white?.main,
              cursor: "pointer",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <benefit.Icon
                style={{ color: palette?.primary?.main, fontSize: `${4 * customfontsize}px` }}
              />
            </Box>
            <Box sx={{ ml: 2, height: "100%" }}>
              <Typography variant="h6" sx={{ fontWeight: "bold",fontSize: `${1.5 * customfontsize}px` ,lineHeight:`${1.5 * customfontsize}px`,my:1 }}>
                {benefit.title}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: `${ customfontsize}px` }}>{benefit.description}</Typography>
            </Box>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default BenefitSection;
